export default [
  {
    word: 'Prontitud',
    type: 'sustantivo',
    pronunciation: 'pron-ti-tud',
    definition: ['Rapidez'],
    context: 'A la hora de responder a los correos, la prontitud da una imagen muy profesional.'
  },
  {
    word: 'Tranquilo',
    type: 'adjetiva',
    pronunciation: 'tran-qui-lo',
    definition: ['sitio, momento'],
    context: 'El mar estaba tranquilo el día que fuimos a Cozumel.'
  },
  {
    word: 'Soporífero',
    type: 'adjetiva',
    pronunciation: 'sa-puh-rih-fihk',
    definition: ['Que mueve o inclina al sueño'],
    context: 'Pero la música seria no fue jamás pensada para ser soporífera.'
  },
  {
    word: 'Espaciosoo',
    type: 'adjetiva',
    pronunciation: 'ehs-pah-syoh-soh',
    definition: ['Amplio, dilatado, vasto'],
    context: 'Este automóvil puede jactarse y el maletero muy espacioso.'
  },
  {
    word: 'Nebuloso',
    type: 'adjetiva',
    pronunciation: 'nehb-yuh-luhs',
    definition: ['Que tiene niebla o está cubierto por ella'],
    context: 'Abandonó el sueño nebuloso de encontrar a su alma gemela y se casó por dinero.'
  }
]
